/* tslint:disable */
/* eslint-disable */
/**
 * BackOffice — Attributions par plateforme
 * Briques d\'un collaborateur par plateforme (override du compte, sémantique d\'override total avec repli sur le compte) et plafond délégable de la plateforme. Keyé par COLLABORATEUR (abpUserId) : un cabinet de N collaborateurs expose N lignes, et les collaborateurs d\'une corporate (sans ligne Courtier) sont adressables. Surface admin de l\'atelier des rôles + surface gouvernance du Portail Plateforme. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetBriquesDelegablesCommand
 */
export interface SetBriquesDelegablesCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof SetBriquesDelegablesCommand
     */
    briques: Array<string>;
}

/**
 * Check if a given object implements the SetBriquesDelegablesCommand interface.
 */
export function instanceOfSetBriquesDelegablesCommand(value: object): value is SetBriquesDelegablesCommand {
    if (!('briques' in value) || value['briques'] === undefined) return false;
    return true;
}

export function SetBriquesDelegablesCommandFromJSON(json: any): SetBriquesDelegablesCommand {
    return SetBriquesDelegablesCommandFromJSONTyped(json, false);
}

export function SetBriquesDelegablesCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetBriquesDelegablesCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'briques': json['briques'],
    };
}

export function SetBriquesDelegablesCommandToJSON(json: any): SetBriquesDelegablesCommand {
    return SetBriquesDelegablesCommandToJSONTyped(json, false);
}

export function SetBriquesDelegablesCommandToJSONTyped(value?: SetBriquesDelegablesCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'briques': value['briques'],
    };
}

